module.exports = __webpack_public_path__ + "mo/img/03_UI-GUI.d3ed57ac.png";